import {useState} from 'react'
import ContactUs from '../../components/ContactUs/ContactUs'
import Footer from '../../components/Footer/Footer'
import Header from '../../components/Header/Header'
import Seo from '../../components/Seo/Seo'
import { PAGE_SEO } from '../../config/seoConfig'

const ContactPage = () => {
    const [carousalStatus, setCarousalStatus] = useState(true);

    const handleClick = (data) => {
      setCarousalStatus(data);
    };
  return (
    <div>
        <Seo {...PAGE_SEO.contact} />
        <Header handleClick={handleClick}/>
        <ContactUs/>
        <Footer/>
    </div>
  )
}

export default ContactPage